import React, { useEffect, useMemo, useState } from 'react';
import DataTable from 'react-data-table-component';
import { FaSearch } from 'react-icons/fa';
import instanciaAxios from '../../../miscelaneo/instanciaAxios';
import SpinnerCargando from '../SpinnerCargando';
import FuncionesGenerales from '../FuncionesGenerales';

/**
 * Tabla para listar egresos (gastos menores)
 * Basado en TablaCompra.js
 */
function TablaEgreso({ setEgresoSeleccionado = () => {} }) {
  const [filtro, setFiltro] = useState('');
  const [egresos, setEgresos] = useState([]);
  const [cargando, setCargando] = useState(true);
  const { formatearFechaInput, formatoMoneda } = FuncionesGenerales();

  const handleRowClick = (egreso) => {
    setEgresoSeleccionado(egreso.id_egreso);
  };

  useEffect(() => {
    (async () => {
      try {
        setCargando(true);
        const res = await instanciaAxios.get('/egreso');
        setEgresos(res.status === 200 ? res.data : []);
      } catch {
        setEgresos([]);
      } finally {
        setCargando(false);
      }
    })();
  }, []);

  const datosFiltrados = useMemo(() => {
    if (!filtro) return egresos;
    const filtroLower = filtro.toLowerCase();
    return egresos.filter((egreso) =>
      egreso?.id_egreso?.toString().includes(filtroLower) ||
      (egreso?.ncf || '').toLowerCase().includes(filtroLower) ||
      (egreso?.concepto || '').toLowerCase().includes(filtroLower) ||
      (egreso?.tipo_egreso || '').toLowerCase().includes(filtroLower) ||
      (egreso?.monto_total?.toString() || '').includes(filtroLower)
    );
  }, [filtro, egresos]);

  const columns = [
    {
      name: 'ID',
      selector: row => row.id_egreso,
      sortable: true,
      width: '70px'
    },
    {
      name: 'NCF',
      selector: row => row.ncf,
      sortable: true,
      width: '150px',
      cell: row => row.ncf
        ? <span className="font-mono">{row.ncf}</span>
        : <span className="text-gray-400 italic">Sin comprobante</span>
    },
    {
      name: 'Concepto',
      selector: row => row.concepto,
      sortable: true,
      wrap: true
    },
    {
      name: 'Tipo',
      selector: row => row.tipo_egreso || '-',
      sortable: true,
      width: '120px'
    },
    {
      name: 'Monto Total',
      selector: row => formatoMoneda(row.monto_total),
      sortable: true,
      width: '120px',
      right: true
    },
    {
      name: 'Fecha',
      selector: row => formatearFechaInput(row.fecha_hora),
      sortable: true,
      width: '110px'
    },
    {
      name: 'Estado DGII',
      sortable: true,
      width: '110px',
      cell: row => {
        // Sin NCF = sin comprobante fiscal
        if (!row.ncf) {
          return <span className="text-gray-400 italic text-xs">N/A</span>;
        }
        // Con NCF y enviado a DGII
        if (row.tiene_e43) {
          return <span className="text-green-600 font-medium">Enviado</span>;
        }
        // NCF físico (serie B) o pendiente
        if (row.ncf?.startsWith('B')) {
          return <span className="text-blue-600 font-medium">Físico</span>;
        }
        return <span className="text-yellow-600 font-medium">Pendiente</span>;
      }
    }
  ];

  if (cargando) return <SpinnerCargando />;

  if (egresos.length === 0) {
    return (
      <div className="text-gray-500 text-center py-8">
        No se encontraron gastos menores.
      </div>
    );
  }

  return (
    <DataTable
      keyField="id_egreso"
      title={
        <h2 className="text-xl font-semibold text-center">Gastos Menores</h2>
      }
      columns={columns}
      data={datosFiltrados}
      pagination
      paginationPerPage={10}
      paginationRowsPerPageOptions={[10, 20, 50]}
      dense
      highlightOnHover
      pointerOnHover
      onRowClicked={handleRowClick}
      noDataComponent={
        <div className="text-gray-500 py-4">No se encontraron gastos menores.</div>
      }
      subHeader
      subHeaderComponent={
        <div className="w-full relative">
          <FaSearch className="absolute right-3 top-1/2 -translate-y-1/2 text-color-secundario" />
          <input
            type="text"
            placeholder="Buscar gasto menor..."
            className="w-full border px-3 py-1 rounded-xl"
            value={filtro}
            onChange={(e) => setFiltro(e.target.value)}
          />
        </div>
      }
    />
  );
}

export default TablaEgreso;







